<ng-template #customLoadingTemplate></ng-template>

<ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '3px', fullScreenBackdrop: true }"
  [template]="customLoadingTemplate"></ngx-loading>
<router-outlet></router-outlet>